//import pdfIcon from "../../Assets/svg/pdf.svg";
import calenderIcon from "../../Assets/svg/calendar-icon.svg";
import filterIcon from "../../Assets/svg/filter-icon.svg";
//import { generatePDF } from "../../Utils/pdf/downloadPdf";
//import { useCallbackState } from "../../Utils/GlobalContext";

interface HeaderProps {
  openOutlookDownload: () => void;
  handleFilterClick: () => void;
  setIsLoading: (status: boolean) => void;
}

function Header({
  openOutlookDownload,
  handleFilterClick,
  //setIsLoading,
}: HeaderProps) {
  /*const handleClick = async () => {
    setIsLoading(true);
    await generatePDF(appointments, pdfIntroData);
    setIsLoading(false);
  };*/

  //const { appointments, pdfIntroData } = useCallbackState();
  return (
    <div className="header-container">
      <button className="header-icon" onClick={openOutlookDownload}>
        <img src={calenderIcon} alt="calendar file icon" />
        <span className="tooltiptext">in Outlook übernehmen</span>
      </button>
      <button className="header-icon" onClick={handleFilterClick}>
        <img src={filterIcon} alt="calendar file icon" />
        <span className="tooltiptext">Termine nach Themen filtern</span>
      </button>
    </div>
  );
}
export default Header;
